import api from './api';

// Štatistiky používania appky a webu. Endpointy sú chránené role='admin'
// (viď backend analytics.routes.js) — vidí ich len super-admin.

const getOverview = () => api.get('/admin/analytics/overview');

const getScreens = (days = 7, platform) =>
    api.get('/admin/analytics/screens', {
        params: platform ? { days, platform } : { days },
    });

const getScreenPaths = (screen, days = 7) =>
    api.get(`/admin/analytics/screens/${encodeURIComponent(screen)}/paths`, {
        params: { days },
    });

const getUsers = (days = 7) =>
    api.get('/admin/analytics/users', { params: { days } });

const getSessions = (days = 7, employeeId) =>
    api.get('/admin/analytics/sessions', {
        params: employeeId ? { days, employee_id: employeeId } : { days },
    });

const getSessionTimeline = (sessionId) =>
    api.get(`/admin/analytics/sessions/${encodeURIComponent(sessionId)}`);

const getPatterns = (days = 7, platform) =>
    api.get('/admin/analytics/patterns', {
        params: platform ? { days, platform } : { days },
    });

const AnalyticsService = {
    getOverview,
    getScreens,
    getScreenPaths,
    getUsers,
    getSessions,
    getSessionTimeline,
    getPatterns,
};

export default AnalyticsService;
